/* eslint-disable react/no-danger */
import React from 'react';
import { CMP_VENDOR, consentGatedScriptProps } from '@/constants/consentManager';

interface FacebookPixelProps {
  facebookId?: string;
}

export function FacebookPixel(props: FacebookPixelProps) {
  const { facebookId } = props;
  if (!facebookId) {
    return null;
  }
  const injectFBString = `
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${facebookId}');
  fbq('track', 'PageView');
  `;
  // Held back by the CMP until the visitor consents to Facebook.
  return (
    <script {...consentGatedScriptProps(CMP_VENDOR.facebook)} dangerouslySetInnerHTML={{ __html: injectFBString }} />
  );
}
